import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Flex,
} from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import { useUserQuery } from "../common/useUserQuery";
import { useVitalsQuery } from "./api/useVitalsQuery";
import { useVitalsDeleteMutation } from "./api/useVitalsMutation";

export default function VitalsContainer() {
  const navigate = useNavigate();
  const { data: userQueryData } = useUserQuery();
  const { data, isFetching, error } = useVitalsQuery(
    userQueryData?.patientUserId
  );
  const { mutate: vitalDelete } = useVitalsDeleteMutation();

  if (isFetching) return "Loading...";

  if (error) return "An error happened, try refreshing the browser.";

  return (
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell as="th">Actions</TableCell>
          <TableCell as="th">Type</TableCell>
          <TableCell as="th">Date</TableCell>
          <TableCell as="th">Value</TableCell>
          <TableCell as="th" display={{ base: "none", medium: null }}>
            Unit
          </TableCell>
          <TableCell as="th" display={{ base: "none", medium: null }}>
            Notes
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data &&
          data.map((vital) => (
            <TableRow key={vital?.id}>
              <TableCell as="td">
                <Button
                  children="Edit"
                  size="small"
                  onClick={() => {
                    navigate(`/user/hr/vitals/${vital?.id}/edit`);
                  }}
                />
                <Button
                  children="Delete"
                  size="small"
                  variation="destructive"
                  onClick={() => vitalDelete(vital?.id)}
                />
              </TableCell>
              <TableCell as="td">{vital?.type}</TableCell>
              <TableCell as="td">{vital?.date}</TableCell>
              <TableCell as="td">{vital?.value}</TableCell>
              <TableCell as="td" display={{ base: "none", medium: null }}>
                {vital?.unit}
              </TableCell>
              <TableCell as="td" display={{ base: "none", medium: null }}>
                {vital?.notes}
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </Table>
  );
}
